import { pb } from "../../helpers/pocketbase_helper"; // Make sure you import your pb instance
import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Form,
  FormFeedback,
  Label,
  Input
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Redux
import { connect, useDispatch } from "react-redux";
import withRouter from 'components/Common/withRouter';

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import { useNavigate } from "react-router-dom";

const UserProfile = props => {
  const dispatch = useDispatch();

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const [rol, setRol] = useState("");
  const [avatar, setavatar] = useState("../../src/assets/images/users/avatar-6.jpg");
  const [avatarFile, setAvatarFile] = useState(null);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rolId, setRolId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (localStorage.getItem("authUser")) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        if (process.env.REACT_APP_DEFAULTAUTH === "pocketbase") {
          setname(obj.record.name);
          setemail(obj.record.email);
          setidx(obj.record.id || 1);

          // Only fetch rol if it changed
          if (obj.record.rol && obj.record.rol !== rolId) {
            try {
              const rolRecord = await pb.collection('rol').getOne(obj.record.rol);
              setRol(rolRecord?.nombre || "");
              setRolId(obj.record.rol);
            } catch (err) {
              setRol("");
            }
          }

          // Only update avatar if it changed
          if (obj.record.avatar && obj.record.avatar !== "" && obj.record.avatar !== avatar) {
            const src = process.env.REACT_APP_PB_URL + "/api/files/users/" + obj.record.id + "/" + obj.record.avatar;
            setavatar(src);
          } else if (!obj.record.avatar || obj.record.avatar === "") {
            setavatar(require("../../assets/images/users/avatar-6.jpg"));
          }
        }
      }
    };
    fetchUserProfile();
    // eslint-disable-next-line
  }, [props.success, avatar, rolId]);

  // Handle avatar file change
  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAvatarFile(file);

    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const userId = obj.record.id;
      const updated = await pb.collection('users').update(userId, { avatar: file });
      obj.record.avatar = updated.avatar;
      localStorage.setItem("authUser", JSON.stringify(obj));
      const src = process.env.REACT_APP_PB_URL + "/api/files/users/" + userId + "/" + updated.avatar;
      setavatar(src);
    } catch (err) {
      alert("Error al actualizar el avatar");
    }
  };

  // Password validation function (at least 8 chars, one uppercase, one lowercase, one number)
  const passwordSchema = Yup.string()
    .required("El password no debe estar vacío.")
    .min(8, "El password debe contener al menos 8 caracteres.")
    .matches(/[a-z]/, "El password debe contener al menos una letra.")
    .matches(/[A-Z]/, "El password debe contener al menos una letra mayuscula.")
    .matches(/[0-9]/, "El password debe contener al menos un número.");
  // Handle password update
  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setPasswordSuccess("");
    setPasswordError("");

    try {
      await passwordSchema.validate(password);
      if (password !== confirmPassword) {
        setPasswordError("Los passwords no coinciden.");
        return;
      }
    } catch (err) {
      setPasswordError(err.message);
      return;
    }

    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const userId = obj.record.id;
      await pb.collection('users').update(userId, {
        oldPassword: oldPassword, // Assuming you have the old password stored
        password: password,
        passwordConfirm: confirmPassword,
      });
      setPasswordSuccess("El password ha sido actualizado exitosamente.");
      setPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        pb.authStore.clear();
        localStorage.removeItem("authUser");
        navigate("/logout");// or use props.history.push("/login") if using react-router
      }, 1500); // Show success for 1.5s before logout
    } catch (err) {
      setPasswordError("Failed to update password.");
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: name || '',
      idx: idx || '',
      rol: rol || '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("PPor favor ingrese su nombre de usuario."),
    }),
    onSubmit: async (values) => {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const userId = obj.record.id;
        // Update name in PocketBase
        const updated = await pb.collection('users').update(userId, {
          name: values.name
        });
        // Update local state and localStorage
        setname(updated.name);
        obj.record.name = updated.name;
        localStorage.setItem("authUser", JSON.stringify(obj));
        // Optionally dispatch Redux action if needed
        // Notify other tabs/components
        window.dispatchEvent(new Event("authUserUpdated"));
      } catch (err) {
        alert("Fallo al actualizar el nombre de usuario.");
      }
    }
  });

  document.title = "Perfil | GraphicForce - Printesco";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Dashboard" breadcrumbItem="Perfil" />

          <Row>
            <Col lg="12">
              {props.error && (
                <Alert color="danger">
                  {typeof props.error === "string"
                    ? props.error
                    : props.error?.message || "Ha ocurrido un error."}
                </Alert>
              )}
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3 text-center">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                        style={{ cursor: "pointer" }}
                        onClick={() => document.getElementById("avatarInput").click()}
                      />
                      <input
                        id="avatarInput"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleAvatarChange}
                      />
                      <div className="small mt-2 text-muted">Click en el avatar para actualizarlo</div>
                    </div>
                    <div className="align-self-center flex-1">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-1">Rol: {rol}</p>
                        <p className="mb-1">Id no: #{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Editar el nombre</h4>

          <Card>
            <CardBody>

              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group">
                  <Label className="form-label">Nombre</Label>
                  <Input
                    name="name"
                    className="form-control"
                    placeholder="Ingrese su nombre"
                    type="text"
                    autoComplete="off"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                  <Input name="idx" value={idx} type="hidden" />
                </div>
                <div className="text-center mt-4">
                  <Button
                    type="submit"
                    color="danger"
                    disabled={
                      !validation.values.name ||
                      validation.values.name === name ||
                      validation.isSubmitting
                    }
                  >
                    Editar el nombre
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
          <h4 className="card-title mb-4">Cambiar el password</h4>
          <Card>
            <CardBody>
              <Form onSubmit={handlePasswordUpdate}>
                <div className="form-group">
                  <Label className="form-label">Password actual</Label>
                  <Input
                    type="password"
                    value={oldPassword}
                    autoComplete="off"
                    onChange={e => setOldPassword(e.target.value)}
                    placeholder="Ingrese el password actual"
                  />
                </div>
                <div className="form-group mt-3">
                  <Label className="form-label">Nuevo password</Label>
                  <Input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Ingrese el nuevo password"
                  />
                </div>
                <div className="form-group mt-3">
                  <Label className="form-label">Confirme el password</Label>
                  <Input
                    type="password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    placeholder="Confirme el nuevo password"
                  />
                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="primary">
                    Actualizar el password
                  </Button>
                </div>
                {passwordSuccess && <Alert color="success" className="mt-3">{passwordSuccess}</Alert>}
                {passwordError && <Alert color="danger" className="mt-3">{passwordError}</Alert>}
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UserProfile)
);
